import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { LanguageContext } from '../context/LanguageContext';

const SEO = ({ title }) => {
    const { language, t } = useContext(LanguageContext);
    const location = useLocation();
    const baseUrl = 'https://hostelnut.com';

    // Get current path without language prefix
    const pathParts = location.pathname.split('/').filter(Boolean);
    const purePath = pathParts.slice(1).join('/');

    const siteTitle = title || t('hero', 'title') || 'Nut Hostel Granada';
    const fullTitle = `${siteTitle} | Nut Hostel Granada`;

    const canonicalUrl = `${baseUrl}${location.pathname}`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <html lang={language.value} />
            <link rel="canonical" href={canonicalUrl} />

            {/* hreflang tags */}
            <link rel="alternate" hreflang="es" href={`${baseUrl}/es/${purePath}`} />
            <link rel="alternate" hreflang="en" href={`${baseUrl}/en/${purePath}`} />
            <link rel="alternate" hreflang="x-default" href={`${baseUrl}/es/${purePath}`} />
        </Helmet>
    );
};

export default SEO;
